module.exports = React.addons.shallowCompare;


/*****************
 ** WEBPACK FOOTER
 ** external "React.addons.shallowCompare"
 ** module id = 4
 ** module chunks = 0
 **/